module.exports = __webpack_public_path__ + "img/1-3.e7ffe098.svg";